<div class="app-loading" *ngIf="loading">
  <div class="loader"></div>
</div>


<div class="main-content" *ngIf="!loading">
  <div class="main-content">
    <div class="container-fluid">

      <!-- Edit/Create Area -->
   
      <div class="card" *ngIf="showRegister" id="editCreateArea">
        <div class="closeButton" (click)="showRegister = false">X</div>
        <div class="row">
          <div class="col-md-12">
            <div class="card-header" *ngIf="true" style="display: flex">
              <div class="text-header" style="width: fit-content;">
                <h4 class="card-title" *ngIf="!productEdit.isEditable">
                  Cadastro de Produtos
                </h4>
                <h4 class="card-title" *ngIf="productEdit.isEditable">
                  Edição de Produtos
                </h4>
                <p>Faça o cadastro de seus produtos.</p>
              </div>
            </div>
            <form name="formProduct" (ngSubmit)="formProduct.form.valid && changeProductList()" #formProduct="ngForm" novalidate>
              <div class="col-md-12 card-footer">
                <div style="height: 85px; width: 100%; display: flex;">
                  <!-- Sku Form -->
                  <div class="col-md-3">
                      <div class="form-group">
                        <label> Sku </label>

                        <input type="text" 
                          class="form-control" 
                          name="sku" 
                          #sku="ngModel" 
                          id="productSku" 
                          placeholder="Insira o Sku"
                          [(ngModel)]="productEdit.productSku"
                          [ngClass]="{ 'colorError': formProduct.submitted &&  validateSku() }" 
                          *ngIf="!productEdit.isEditable" required 
                        /> 

                        <input type="text" 
                          class="form-control" 
                          name="sku" 
                          #sku="ngModel"
                          id="productSku"
                          placeholder="Insira o Sku"
                          [(ngModel)]="productEdit.productSku" 
                          [ngClass]="{ colorError: formProduct.submitted && validateSku() }"   
                          *ngIf="productEdit.isEditable" required
                        />     

                        <small *ngIf="formProduct.submitted && validateSku()" >Ops! O SKU é um dado obrigatório!</small>

                      </div>
                  </div>

                  <!--  Id Form -->
                  <div class="col-md-3">
                    <div class="form-group">
                      <label> Id </label>

                      <input type="text" 
                        class="form-control" 
                        name="id" 
                        id="productId" 
                        placeholder="Insira o Id" 
                        [ngClass]="{ 'colorError': formProduct.submitted && validateId() }"
                        [(ngModel)]="productEdit.productId" 
                        *ngIf="!productEdit.isEditable" 
                        required 
                      />

                      <input type="text" 
                        class="form-control" 
                        name="id"
                        id="productId"
                        placeholder="Insira o Id"
                        [(ngModel)]="productEdit.productId"   
                        [ngClass]="{ 'colorError': formProduct.submitted && validateId() }"
                        *ngIf="productEdit.isEditable" 
                        required  
                      />
                      
                      <small *ngIf="formProduct.submitted && validateId()" >Ops! O Id é um campo obrigatório!</small>
                      
                    </div>
                  </div>

                  <!-- Donation Form -->
                  <div class="col-md-2">
                    <div class="form-group">
                      <label> Doação </label>

                      
                      <input type="number" 
                        min="0"
                        max="100" 
                        accuracy="2"
                        style="text-align:left;"
                        name="donation" 
                        id="donation" 
                        class="form-control" 
                        [ngClass]="{ 'colorError': formProduct.submitted && validateDonation() }"
                        [(ngModel)]="productEdit.donation"  
                        placeholder="Insira a % da doação"
                        *ngIf="!productEdit.isEditable" 
                        required  
                      />
                      <span class="valuePadding">%
                      </span>
                        
                      <input type="number" 
                        min="0" 
                        max="100" 
                        accuracy="2"
                        style="text-align:left;"
                        name="donation"
                        id="donation" 
                        class="form-control" 
                        [ngClass]="{ 'colorError': formProduct.submitted && validateDonation() }"
                        [(ngModel)]="productEdit.donation"  
                        placeholder="Insira a % da doação" 
                        *ngIf="productEdit.isEditable" 
                        required                          
                      /> <span class="valuePadding">%
                      </span>

                      
                      <small *ngIf="formProduct.submitted && validateDonation()" >Ops! A doação deve se manter entre 1 e 100%</small>
                
                    </div>
                  </div>

                </div>
                 <!-- Name Form -->
                 <div class="col-md-12">
                  <div class="form-group">
                    <label for="productStore">Produto</label>

                    <input type="text" 
                      class="form-control" 
                      name="name" 
                      id="productName"
                      placeholder="Insira o Nome do Produto"
                      [(ngModel)]="productEdit.productName" 
                      [ngClass]="{ 'colorError': formProduct.submitted && validateName() }" 
                      *ngIf="!productEdit.isEditable"
                      required 
                    />

                    <input type="text" 
                      class="form-control"
                      name="name" 
                      id="productName" 
                      placeholder="Insira o Nome do Produto"
                      [(ngModel)]="productEdit.productName" 
                      [ngClass]="{ 'colorError': formProduct.submitted && validateName() }" 
                      *ngIf="productEdit.isEditable"  
                      required 
                    />

                    <small *ngIf="formProduct.submitted && validateName()" >Ops! O Nome do Produto é um campo obrigatório!</small>

                  </div>
                </div>

                 <!-- Url Form -->
                 <div class="col-md-12">
                  <div class="form-group">
                    <label for="productStore">URL</label>

                    <input type="text" 
                      class="form-control" 
                      name="url" 
                      id="productUrl" 
                      placeholder="Insira a URL" 
                      [ngClass]="{ 'colorError': formProduct.submitted && validateUrl() }"
                      [(ngModel)]="productEdit.productUrl" 
                      *ngIf="!productEdit.isEditable" 
                      required  
                    />

                    <input type="text" 
                      class="form-control"
                      name="Url" 
                      id="productUrl" 
                      placeholder="Insira a URL" 
                      [(ngModel)]="productEdit.productUrl" 
                      [ngClass]="{ 'colorError': formProduct.submitted && validateUrl() }"
                      *ngIf="productEdit.isEditable" 
                      required 
                    />
                    
                    <small *ngIf="formProduct.submitted && validateUrl()">Ops! A Url é um campo obrigatório!</small>

                  </div>
              </div>
              

              </div>

              <div class="text-right">
                <button type="submit" value="OK" class="btn btn-info btn-fill polen-btn-spacing" *ngIf="productEdit.isEditable">
                  Editar
                </button>
                <button  type="submit" value="OK" class="btn btn-info btn-fill polen-btn-spacing" *ngIf="!productEdit.isEditable">
                  Cadastrar
                </button>
              </div>

            </form>
          </div>
        </div>
      </div>

      <div class="card">
        <div class="row">
          <div class="col-sm-12">
            <div class="card-header" *ngIf="true">
              <button (click)="editProduct(null)" class="btn btn-info btn-fill"
                style="height: fit-content;  margin: 5px 0 0px auto; float:right">
                Novo Cadastro
              </button>
              <h4 class="card-title">
                Seus Produtos
              </h4>
              <div class="table-responsive">
                <table id="datatables" class="table table-striped table-no-bordered table-hover dataTable dtr-inline"
                  cellspacing="0" width="100%" style="width: 100%;" role="grid" aria-describedby="datatables_info">
                  <thead class="thead-light">
                    <tr role="row">
                      <th scope="col">Sku</th>
                      <th scope="col">Produto</th>
                      <th scope="col">URL</th>
                      <th scope="col">Id</th>
                      <th scope="col">Doação</th>
                      <th scope="col">Ação</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let product of productsList; let i = index" role="row" class="odd">
                      <td class="sorting_1">
                        {{product.productSku}}
                      </td>
                      <td>
                        {{product.productName}}
                      </td>
                      <td>
                        {{product.productUrl}}
                        </td>
                        <td>
                        {{product.productId}}
                          </td>
                      <td>
                        {{product.donation}}%
                      </td>
                      <td style="
                      display: flex;">
                        <button (click)="editProduct(product)" href="#top" class="btn btn btn-sm" style="
                        margin-right: 6px;" >Editar</button>
                        <button (click)="deleteProduct(product)" type="button" class="btn btn btn-sm btn-danger">
                          <span class="btn-label"><i class="fa fa-times"></i></span>
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>